// src/utils/sessionBus.js
export const SESSION_EXPIRED_EVENT = "session-expired";
const bc = "BroadcastChannel" in window ? new BroadcastChannel("session") : null;

const PENDING_KEY = "SEM_PENDING";


function isAuthRoute() {
  try {
    const p = window.location?.pathname || "/";
    return ["/", "/login", "/signup", "/forgot-password"].includes(p);
  } catch { return false; }
}

export function notifySessionExpired() {
  if (window.__SESSION_EXPIRED_SHOWN__) return;
  window.__SESSION_EXPIRED_SHOWN__ = true;

  // Marked as "To Display"
  try { localStorage.setItem(PENDING_KEY, "1"); } catch {}

  // Current TAB
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));

  // Other TAB
  if (bc) {
    bc.postMessage({ type: "expired" });
  } else {
    try { localStorage.setItem("SESSION_EXPIRED_AT", String(Date.now())); } catch {}
  }
}

export function attachSessionListeners(onExpired) {
  const handler = () => {
    if (isAuthRoute()) return; // Ignore it directly on the login page
    onExpired?.();
  };

  window.addEventListener(SESSION_EXPIRED_EVENT, handler);

  let bcHandler = null;
  if (bc) {
      bcHandler = (e) => {
        if (e?.data?.type === "expired") handler(); // The login page suppression has been implemented in the handler
    };
    bc.addEventListener("message", bcHandler);
  }

  const onStorage = (e) => {
    if (e.key === "SESSION_EXPIRED_AT") handler();
  };
  window.addEventListener("storage", onStorage);
    try {
      if (localStorage.getItem(PENDING_KEY) === "1" && !isAuthRoute()) {
      onExpired?.();
        }
    } catch {}

  return () => {
    window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
    window.removeEventListener("storage", onStorage);
    if (bc && bcHandler) bc.removeEventListener("message", bcHandler);
  };
}
// Provide a cleanup function and use it after clicking "Go to login"
export function clearSessionExpiredFlag() {
  window.__SESSION_EXPIRED_SHOWN__ = false;
  try { localStorage.removeItem(PENDING_KEY); } catch {}
}
